export default __webpack_public_path__ + "static/media/soccer-club.71c68cb7.png";